/*
  Laat de hoofdfoto meewisselen met de gekozen kleur.

  Waarom dit nodig is: geen enkele variant heeft in Shopify een eigen
  afbeelding gekregen, dus Dawn weet niet welke foto bij welke kleur hoort en
  laat de galerij staan. De veertien kleurfoto's staan er wel, met de kleurnaam
  als bestandsnaam. Deze koppeling legt dat verband alsnog in de etalage.

  Dawn bouwt na een variantwissel de hele productsectie opnieuw op, dus we
  binden aan het document en zoeken de galerij elke keer opnieuw op.

  Dit blijft een noodverband. Zodra elke variant in de beheeromgeving zijn
  eigen afbeelding heeft, doet Shopify dit zelf en werkt het ook in de
  winkelwagen, in zoekresultaten en op de collectiepagina.
*/
(function () {
  function normaliseer(tekst) {
    return String(tekst || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function register() {
    var lijst = [];
    document.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
      var doel = item.getAttribute('data-target');
      var img = item.querySelector('img');
      if (!doel || !img) return;
      var bestand = (img.currentSrc || img.src || '').split('/').pop().split('?')[0];
      lijst.push({ sleutel: normaliseer(bestand.replace(/\.[a-z0-9]+$/i, '')), doel: doel });
    });
    return lijst;
  }

  function zoekMedia(kleur, lijst) {
    var k = normaliseer(kleur);
    if (!k) return null;
    var exact = lijst.filter(function (r) {
      return r.sleutel === k;
    });
    if (exact.length === 1) return exact[0].doel;
    var begint = lijst.filter(function (r) {
      return r.sleutel.indexOf(k) === 0;
    });
    return begint.length === 1 ? begint[0].doel : null;
  }

  function huidigeKleur() {
    var gekozen = document.querySelector(
      '.product-form__input--swatch input:checked, .product-form__input--pill input:checked'
    );
    if (gekozen) return gekozen.value;
    var select = document.querySelector('.product-form__input select');
    return select ? select.value : null;
  }

  function actieveFoto() {
    var zichtbaar = document.querySelector('.product__media-wrapper:not([hidden]) img');
    return zichtbaar ? (zichtbaar.currentSrc || zichtbaar.src) : '';
  }

  /* Dawn haalt de nieuwe sectie op via fetch; hoe lang dat duurt weten we niet.
     Daarom een paar pogingen, en stoppen zodra het gelukt is. */
  function pas(pogingen) {
    var kleur = huidigeKleur();
    if (!kleur) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') {
      if (pogingen > 0) return setTimeout(pas, 160, pogingen - 1);
      return;
    }
    var doel = zoekMedia(kleur, register());
    if (!doel) return;

    var voor = actieveFoto();
    gallery.setActiveMedia(doel, true);

    if (pogingen > 0) {
      setTimeout(function () {
        if (actieveFoto() === voor) pas(pogingen - 1);
      }, 220);
    }
  }

  document.addEventListener(
    'change',
    function (e) {
      if (!e.target.closest('.product-form__input, variant-selects')) return;
      pas(6);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pas(4);
    });
  } else {
    pas(4);
  }
})();
